import React from 'react';
import '../../styles/chatbot-listings.css';

const ChatbotListingCards = ({ listings }) => {
  if (!listings || listings.length === 0) return null;

  return (
    <div className="chatbot-listing-cards">
      {listings.map(listing => (
        <div key={listing.id} className="chatbot-listing-card">
          <div className="chatbot-listing-card-title">{listing.title}</div>

          <div className="chatbot-listing-card-details">
            <div className="chatbot-listing-card-detail">
              <span className="chatbot-listing-card-detail-icon">👤</span>
              <span className="chatbot-listing-card-detail-label">Provider:</span>
              <span>{listing.author}</span>
            </div>

            <div className="chatbot-listing-card-detail">
              <span className="chatbot-listing-card-detail-icon">💰</span>
              <span className="chatbot-listing-card-detail-label">Price:</span>
              <span>{listing.price}</span>
            </div>
          </div>

          {listing.description && (
            <div className="chatbot-listing-card-description">📝 {listing.description}</div>
          )}

          <a
            href={listing.url}
            target="_blank"
            rel="noopener noreferrer"
            className="chatbot-listing-card-button"
          >
            View Full Details →
          </a>
        </div>
      ))}
    </div>
  );
};

export default ChatbotListingCards;
